<script setup lang="ts">
  import { getCurrentInstance } from 'vue';
  import PosUiButton from '@/components/pos-v2/ui/PosUiButton.vue';
  import PosUiSettingsCard from '@/components/pos-v2/ui/PosUiSettingsCard.vue';
  import type { IFocalPoint } from '@/interfaces/IStorefrontStyle';
  import V2DesignFocalPicker from './V2DesignFocalPicker.vue';

  /**
   * «Foto de portada» (Storefront V2 ADM-3): the focal picker when the store
   * has a banner; otherwise a note and the way to upload one.
   */
  defineProps<{
    bannerUrl?: string;
    logoUrl?: string;
    focal?: IFocalPoint;
  }>();
  const emit = defineEmits<{
    (e: 'input', focal: IFocalPoint): void;
    (e: 'upload'): void;
  }>();

  const proxy = getCurrentInstance()!.proxy;
  const t = (key: string) => String(proxy.$t(key));
</script>

<template>
  <PosUiSettingsCard
    class="v2-design-cover-card"
    :title="t('design.cover.title')"
    :description="bannerUrl ? t('design.cover.hint') : undefined"
  >
    <V2DesignFocalPicker
      v-if="bannerUrl && focal"
      :src="bannerUrl"
      :value="focal"
      :logo="logoUrl"
      @input="emit('input', $event)"
    />
    <div v-else class="cover-empty">
      <p class="empty-text">{{ t('design.cover.none') }}</p>
      <PosUiButton
        color="neutral"
        variant="outline"
        icon="image-plus"
        @click="emit('upload')"
      >
        {{ t('design.cover.upload') }}
      </PosUiButton>
    </div>
  </PosUiSettingsCard>
</template>

<style scoped lang="scss">
  .v2-design-cover-card {
    .cover-empty {
      @apply tw-flex tw-flex-col tw-items-start tw-rounded-lg tw-bg-neutral-100 tw-p-4;

      .empty-text {
        @apply tw-m-0 tw-mb-3 tw-text-sm tw-leading-relaxed tw-text-neutral-700;
      }
    }
  }
</style>
